export default __webpack_public_path__ + "static/media/healthcare.8aa43391.svg";